<template>
  <div :class="className">{{ timerInSeconds |  formatTimerFilter(showHours) }}</div>
</template>

<script>
import {formatTime} from '../../../helpers/common'

export default {
  name: 'BaseCountdownTimer',
  emits: ['time:expired'],
  props: {
    initialTimerInSeconds: {
      type: Number,
      default: 0
    },
    startImmediate: {
      type: Boolean,
      default: true
    },
    timerFormat: {
      type: String,
      default: 'mm:ss',
      validator: function (value) {
        return ['hh:mm:ss', 'mm:ss'].includes(value)
      }
    },
    className: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatTimerFilter: (value, showHours) => formatTime(value, '', {showHours})
  },
  data () {
    return {
      timerInSeconds: 0,
      timerIntervalId: null,
      timerIntervalDelay: 1000
    }
  },
  mounted () {
    if (this.startImmediate) {
      this.$nextTick(() => {
        this.startTimer()
      })
    }
  },
  computed: {
    showHours () {
      return this.timerFormat === 'hh:mm:ss'
    }
  },
  methods: {
    startTimer (initialTimer) {
      this.timerInSeconds = initialTimer || this.initialTimerInSeconds

      if (this.timerInSeconds <= 0) { return }

      this.timerIntervalId = setInterval(() => {
        --this.timerInSeconds

        if (this.timerInSeconds <= 0) {
          clearInterval(this.timerIntervalId)
          this.timerIntervalId = null

          this.$emit('time:expired')
        }
      }, this.timerIntervalDelay)
    },
    stopTimer () {
      if (this.timerIntervalId) {
        clearInterval(this.timerIntervalId)
      }
    }
  },
  beforeDestroy () {
    this.stopTimer()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/timer/BaseCountdownTimer.vue